import { QueryClient } from '@tanstack/react-query';
import type { ApiClient } from './apiRuntime';

// Keyed by QueryClient because TanStack hands every query and mutation function the client that
// runs it (context.client). That channel cannot point at another request, which is why the
// credentials travel over it and never through anything ambient.
const apis = new WeakMap<QueryClient, ApiClient>();

export function bindApi(queryClient: QueryClient, api: ApiClient): void {
    const bound = apis.get(queryClient);
    if (bound && bound !== api) {
        throw new Error('This QueryClient already has an Api; every runtime needs its own QueryClient.');
    }
    apis.set(queryClient, api);
}

export function apiOf(queryClient: QueryClient): ApiClient {
    const api = apis.get(queryClient);
    if (!api) {
        throw new Error('No Api is bound to this QueryClient; create it with createApiRuntime().');
    }
    return api;
}
